import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link, Navigate } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Footer } from "../components/Footer";
import { Logo } from "../components/Logo";
import { LEGAL_PAGES } from "../content";

const EASE = [0.22, 1, 0.36, 1];

export default function InfoPage({ page }) {
  const data = LEGAL_PAGES[page];
  if (!data) return <Navigate to="/" replace />;

  return (
    <div data-testid="info-page" className="min-h-screen bg-ink text-paper">
      <Seo title={data.title} description={data.description} path={`/${page}`} />
      <header className="border-b border-white/[0.08] bg-ink/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3.5 sm:px-6 lg:px-8">
          <Link to="/" data-testid="info-logo" className="flex items-center gap-2.5">
            <Logo size={26} />
            <span className="font-display text-lg font-extrabold tracking-tight text-acid">DMWrapped</span>
          </Link>
          <Link
            to="/"
            data-testid="info-back"
            className="flex items-center gap-1.5 rounded-full border border-white/[0.12] px-4 py-2 text-sm font-semibold text-dim transition-colors hover:border-acid/50 hover:text-paper"
          >
            <ArrowLeft size={15} /> Back
          </Link>
        </div>
      </header>

      <motion.main
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24"
      >
        <h1 data-testid="info-title" className="font-display text-4xl font-extrabold tracking-tight text-paper sm:text-5xl">
          {data.title}
        </h1>
        {data.updated && <p className="mt-3 text-sm text-dim">Last updated {data.updated}</p>}

        <div className="mt-10 space-y-8">
          {data.sections.map((s, i) => (
            <section key={i} data-testid={`info-section-${i}`}>
              {s.heading && (
                <h2 className="mb-2 font-display text-lg font-bold tracking-tight text-paper">
                  {s.heading}
                </h2>
              )}
              <p className="text-[15px] leading-relaxed text-[#E1E2E6]">{s.body}</p>
            </section>
          ))}
        </div>
      </motion.main>
      <Footer />
    </div>
  );
}
